import { RestAPI } from './rest-api.service';
import { BASE_URL } from '../types/constants';
import { HomeCollection } from '../types/home.types';

const api = new RestAPI();

/**
 * Public collections feed.
 * Endpoint: GET /v1/collections
 */
export const fetchCollections = async (): Promise<HomeCollection[]> => {
    const url = `${BASE_URL}/v1/collections`;
    return api.get(url);
};
